import { ATTRIBUTE_KEYS } from '@/constant/constant';

// mapping
const ATTRIBUTE_LABELS = {
  [ATTRIBUTE_KEYS.DELIVERY_CHARGES]: 'Delivery Charges',
  [ATTRIBUTE_KEYS.MINIMUM_ORDER]: 'Minimum Order',
  [ATTRIBUTE_KEYS.SHOP_TIMING]: 'Shop Timing',
  [ATTRIBUTE_KEYS.OFF_HOURS]: 'Break / Off-Hours',
  [ATTRIBUTE_KEYS.WEEKLY_OFF_DAY]: 'Weekly Off Day',
  [ATTRIBUTE_KEYS.IS_FRANCHISE]: 'Franchise or Authorized Dealer',
  [ATTRIBUTE_KEYS.FRANCHISE_NAME]: 'Franchise Brand Name',
  [ATTRIBUTE_KEYS.BUSSINESS_TYPE]: 'Business Type',
  [ATTRIBUTE_KEYS.PRODUCT_DELIVERY_TYPE]: 'Product Delivery Type',
  [ATTRIBUTE_KEYS.SERVICE_DELIVERY_TYPE]: 'Service Delivery Type',
  [ATTRIBUTE_KEYS.SUBSCRIPTION_DELIVERY_TYPE]: 'Subscription Delivery Type',
  [ATTRIBUTE_KEYS.DELIVERY_METHOD]: 'Delivery Method',
  [ATTRIBUTE_KEYS.DELIVERY_PREPARATION_TIME]: 'Delivery Preparation Time',
  [ATTRIBUTE_KEYS.DELIVERY_SLOTS]: 'Delivery Slots',
  [ATTRIBUTE_KEYS.IS_EXPRESS_DELIVERY]: 'Express Delivery',
  [ATTRIBUTE_KEYS.ESTABLISHED_YEAR]: 'Established Year',
  [ATTRIBUTE_KEYS.GST_NO]: 'GST Number',
  [ATTRIBUTE_KEYS.PAN_NO]: 'PAN Number',
  [ATTRIBUTE_KEYS.CERTIFICATIONS]: 'Certifications',
  [ATTRIBUTE_KEYS.UDYAM_NO]: 'Udyam Registration Number',
  [ATTRIBUTE_KEYS.MIN_DAYS]: 'Minimum Days',
  [ATTRIBUTE_KEYS.MAX_DAYS]: 'Maximum Days',
  [ATTRIBUTE_KEYS.FACEBOOK]: 'FACEBOOK',
  [ATTRIBUTE_KEYS.YOUTUBE]: 'YOUTUBE',
  [ATTRIBUTE_KEYS.INSTAGRAM]: 'INSTAGRAM',
  [ATTRIBUTE_KEYS.WEBSITE]: 'WEBSITE',
  [ATTRIBUTE_KEYS.TAGLINE]: 'TAGLINE',
  [ATTRIBUTE_KEYS.ABOUT_US]: 'ABOUT US',
  [ATTRIBUTE_KEYS.VENDOR_UPI_ID]: 'VENDOR UPI ID',
  [ATTRIBUTE_KEYS.PAYMENT_METHODS]: 'Payment Methods',
  [ATTRIBUTE_KEYS.LOGISTICS_TYPE]: 'Delivery Options',
};

function generateLabelFromCamelCase(camelCaseStr) {
  if (!camelCaseStr || typeof camelCaseStr !== 'string') {
    return '';
  }

  // Add a space before each capital letter, then capitalize the first letter.
  const withSpaces = camelCaseStr.replace(/([A-Z])/g, ' $1');
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

export function getAttributeLabel(attributeName) {
  return ATTRIBUTE_LABELS[attributeName] || generateLabelFromCamelCase(attributeName);
}
